import React, { useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Btn, Input, Field, Modal } from "@/components/ui-kit";

export function ChangePasswordModal({ onClose }) {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async () => {
    if (f.new_password !== f.confirm) { toast.error("New passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password changed");
      onClose();
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail));
    }
    setBusy(false);
  };

  return (
    <Modal open onClose={onClose} title="Change Password">
      <div className="space-y-3" data-testid="change-password-modal">
        <Field label="Current Password" required><Input data-testid="cp-current" type="password" value={f.current_password} onChange={set("current_password")} /></Field>
        <Field label="New Password (min 8)" required><Input data-testid="cp-new" type="password" value={f.new_password} onChange={set("new_password")} /></Field>
        <Field label="Confirm New Password" required><Input data-testid="cp-confirm" type="password" value={f.confirm} onChange={set("confirm")} /></Field>
        <div className="flex justify-end gap-2">
          <Btn variant="outline" onClick={onClose}>Cancel</Btn>
          <Btn onClick={save} disabled={busy} data-testid="cp-submit">{busy ? "Saving…" : "Change"}</Btn>
        </div>
      </div>
    </Modal>
  );
}
